import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = ({...props}) => {
  return (
    <Svg width="40" height="40" viewBox="0 0 74 74" fill="none" {...props}>
        <g clipPath="url(#clip0_2331_10387)">
        <circle cx="37" cy="37" r="37" fill="#0090FD"/>
        <path d="M41.1076 53H33.7433C28.9315 53 25.0293 49.1808 25.0293 44.476C25.0293 43.3413 26.0269 42.4004 27.2298 42.4004C28.4328 42.4004 29.4303 43.3413 29.4303 44.476C29.4303 46.8838 31.3667 48.8487 33.7433 48.8487H41.1076C43.0147 48.8487 44.599 47.2435 44.599 45.3063C44.599 42.8985 43.6895 42.428 42.1932 41.9299L30.3692 38C28.0807 37.2528 25 35.6476 25 30.6937C25 26.4317 28.5501 23 32.8924 23H40.2567C45.0685 23 48.9707 26.8192 48.9707 31.524C48.9707 32.6587 47.9731 33.5996 46.7702 33.5996C45.5672 33.5996 44.5697 32.6587 44.5697 31.524C44.5697 29.1162 42.6333 27.1513 40.2567 27.1513H32.8924C30.9853 27.1513 29.401 28.7565 29.401 30.6937C29.401 33.1015 30.3105 33.572 31.8068 34.0701L43.6308 38C45.9193 38.7472 49 40.3524 49 45.3063C48.9707 49.5406 45.4499 53 41.1076 53Z" fill="white"/>
        <path d="M37 57C35.36 57 34 56.043 34 54.8889V21.1111C34 19.957 35.36 19 37 19C38.64 19 40 19.957 40 21.1111V54.8889C40 56.043 38.64 57 37 57Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_2331_10387">
        <rect width="74" height="74" fill="white"/>
        </clipPath>
        </defs>
    </Svg>
  );
};

export default Icon;
